export const allowedOrgIds = [
  "299572ae-1024-4554-9e22-f4e30bea955b",
  "org-xyz",
];

export const orgIDMap: Record<string, string> = {
  "299572ae-1024-4554-9e22-f4e30bea955b": "RED_RHINO",
  "org-xyz": "TEST",
};
